






















import { Component, Prop } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import EntityType from '@/models/Shared/EntityType';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';
import { ProductIssueDetailsModule } from '@/store/Products/ProductIssueDetailsModule';
import SecondaryWalletsGeneralSettings from '@/components/Products/ProductSettings/SecondaryWallets/General/SecondaryWalletsGeneralSettings.vue';
import SecondaryWalletsList from '@/components/Products/ProductSettings/SecondaryWallets/Savings/SecondaryWalletsList.vue';

@Component({ name: 'SecondaryWalletsTabs', components: { SecondaryWalletsGeneralSettings, SecondaryWalletsList } })
export default class extends SaascadaVue {

    EntityType = EntityType;

    @Prop({required: true})
    entityType: EntityType;

    tabIndex = 0;

    get secondaryWalletTypeSettingsAvailable() {
        if (this.entityType === EntityType.Product) {
            return ProductDetailsModule.product.secondaryWalletSettings;
        }
        return ProductIssueDetailsModule.productIssue.secondaryWalletSettings;
    }

}
